module.exports = __webpack_public_path__ + "static/media/kairos-logo-blue.b58f7f21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/kairos-logo-blue.svg
// module id = 399
// module chunks = 0